export type ClipboardResult = { success: true } | { success: false; error: Error };

export async function copyTextToClipboard(text: string): Promise<ClipboardResult> {
    try {
        await navigator.clipboard.writeText(text);
        return { success: true };
    } catch (error) {
        return { success: false, error: error instanceof Error ? error : new Error(String(error)) };
    }
}

export async function copyBlobToClipboard(blob: Blob, mimeType: string): Promise<ClipboardResult> {
    try {
        await navigator.clipboard.write([new ClipboardItem({ [mimeType]: blob })]);
        return { success: true };
    } catch (error) {
        return { success: false, error: error instanceof Error ? error : new Error(String(error)) };
    }
}
